import { render, staticRenderFns } from "./PagePerformanceReviewTemplateCreate.vue?vue&type=template&id=25383f0e&"
import script from "./PagePerformanceReviewTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports